module.exports = __webpack_public_path__ + "static/media/logoslogan.f6f57882.png";